import request from '@/utils/request'

// 按 name 或 type 搜索匹配的字典
export function getDicyType({ name, type }) {
  const payload = {
    where: {
      "eq_dt.name": name || undefined,
      "eq_dt.type": type || undefined,
    },
  };
  return request.post('/sys/dict/list', payload);
}

// 按 name 或 type 搜索匹配的字典
export function getDictOne({ name, type }) {
  const payload = {
    where: {
      "eq_dt.name": name || undefined,
      "eq_dt.type": type || undefined,
    },
  };
  return request.post('/sys/dict/list', payload).then(res => {
    if (res.status === 200 && res.data.code === 2000) {
      if (res.data.data && Array.isArray(res.data.data) && res.data.data.length) {
        return res.data.data[0].dictDataList || []
      }
    }
    return []
  });
}

// 获取字典列表
export function getList(data) {
  return request.post('/sys/dict/list', data)
}

// 新增字典类型
export function createDict(data) {
  return request.post('/sys/dict/add', data)
}

// 修改字典类型
export function updateDict(data) {
  return request.post('/sys/dict/updateType', data)
}

// 删除字典类型
export function deleteDict(data) {
  const url = "/sys/dict/delType?id=" + data;
  return request.post(url)
}

// 新增字典数据
export function createData(data) {
  return request.post('/sys/dict/addData', data)
}

// 修改字典数据
export function updateData(data) {
  return request.post('/sys/dict/updateData', data)
}

// 删除字典数据
export function deleteData(data) {
  const url = "/sys/dict/delData?id=" + data;
  return request.post(url)
}

